/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TclCorestackAttributeMapping {
    getFixupPrototypeFunction() { return TclCorestackAttributeMapping.fixupPrototype; }

    static newInstance(model: Partial<TclCorestackAttributeMapping>): TclCorestackAttributeMapping {
        let obj = Object.assign(new TclCorestackAttributeMapping(), model);
        TclCorestackAttributeMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TclCorestackAttributeMapping>): TclCorestackAttributeMapping {
        if (!model) return null;
        return TclCorestackAttributeMapping.newInstance(<TclCorestackAttributeMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TclCorestackAttributeMapping) {
        if (!obj) return;

        models.TclCorestackAttributeMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TclCorestackAttributeMapping): boolean {
        Object.setPrototypeOf(obj, TclCorestackAttributeMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * TCL attribute of the resource
     */
    tcl_attribute: string;

    /**
     * Corestack attribute of the resource
     */
    corestack_attribute: string;

}
